module.exports = __webpack_public_path__ + "static/img/custom_preview.98727053.png";